import axiosInstance from "../axios/axiosInstance";
import config from "./Config";
import AuthorizationService from './AuthorizationService';
import RoleService from "./RoleService";

export default class AgendaPrestadorService {

    async listAgendaPrestadores(iss) {
        const accessLevel = AuthorizationService.getResourceAccessLevel('agenda');
        const idPrestador = RoleService.getPrestador();

        switch (accessLevel) {
            case 'GLOBAL':
                return this.listAllAgendaPrestador(iss);
            case 'COMPANY':
                return this.listAllAgendaPrestador(iss);
            case 'SELF':
                return this.listAllAgendaPrestadorByPrestador(iss, idPrestador);
            default:
                throw new Error('Acesso não autorizado');
        }
    }

    listAllAgendaPrestador(data) {
        return axiosInstance.get(`${config.api.version}/agenda/${data}/get`)
    }

    listAllAgendaPrestadorByPrestador(data, idPrestador) {
        return axiosInstance.get(`${config.api.version}/agenda/${data}/get?prestadorTipoAgendamento.prestador.id=${idPrestador}&join=true`)
    }

    getAgendaPrestador(data, id) {
        var params = { all: true }
        return axiosInstance.get(`${config.api.version}/agenda/${data}/get/${id}`, {
            params: params
        })
    }

    postAgendaPrestador(data, agenda) {
        return axiosInstance.post(`${config.api.version}/agenda/${data}/`, agenda)
    }

    putAgendaPrestador(data, agenda, id) {
        return axiosInstance.put(`${config.api.version}/agenda/${data}/${id}`, agenda)
    }

    deleteAgendaPrestador(data, id) {
        return axiosInstance.delete(`${config.api.version}/agenda/${data}/${id}`)
    }
}